import { LitElement, html, nothing } from 'lit';

customElements.define('ks-progress-bar', class extends LitElement {
  static properties() {
    return {
      active: { reflect: true },
    }
  };

  createRenderRoot() {
    return this;
  }

  render() {
    return html``;
    
  }
});
